/**
 * Convert a hex color string to an RGB triplet string for use with
 * Tailwind CSS custom properties.
 *
 * Examples:
 *   hexToRgbTriplet('#2563eb') → '37 99 235'
 *   hexToRgbTriplet('#fff')    → '255 255 255'
 *   hexToRgbTriplet('invalid') → null
 */
export function hexToRgbTriplet(hex: string): string | null {
  // Normalize shorthand (#abc → #aabbcc)
  let normalized = hex.replace(/^#/, '')
  if (normalized.length === 3) {
    normalized = normalized[0] + normalized[0] + normalized[1] + normalized[1] + normalized[2] + normalized[2]
  }

  const match = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(normalized)
  if (!match) return null

  return `${parseInt(match[1], 16)} ${parseInt(match[2], 16)} ${parseInt(match[3], 16)}`
}
